import ListingProfile from './ListingProfile'

export default ListingProfile
